import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button, Input, Alert } from '../../components/common';
import './AuthPages.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, error, clearError } = useAuth();

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState('');

  // 如果来源是登录页，则跳转到首页；否则跳转回原页面
  const fromPath = location.state?.from?.pathname;
  const from = (!fromPath || fromPath === '/login') ? '/' : fromPath;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setLocalError('');
    clearError();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username || !formData.password) {
      setLocalError('请输入用户名/邮箱和密码');
      return;
    }

    setLoading(true);
    const result = await login(formData.username, formData.password);
    setLoading(false);

    if (result.success) {
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-background">
        <div className="auth-bg-shape auth-bg-shape-1"></div>
        <div className="auth-bg-shape auth-bg-shape-2"></div>
        <div className="auth-bg-shape auth-bg-shape-3"></div>
      </div>

      <div className="auth-container">
        <div className="auth-card animate-slideUp">
          <div className="auth-header">
            <div className="auth-logo">
              <svg viewBox="0 0 40 40" fill="none">
                <rect width="40" height="40" rx="10" fill="url(#logo-gradient)" />
                <path
                  d="M20 10L28 26H12L20 10Z"
                  fill="white"
                  fillOpacity="0.9"
                />
                <circle cx="20" cy="28" r="3" fill="white" />
                <defs>
                  <linearGradient id="logo-gradient" x1="0" y1="0" x2="40" y2="40">
                    <stop stopColor="#0d9488" />
                    <stop offset="1" stopColor="#0f766e" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h1 className="auth-title">欢迎回来</h1>
            <p className="auth-subtitle">请登录您的账号</p>
          </div>

          {(error || localError) && (
            <Alert
              type="error"
              message={error || localError}
              onClose={() => {
                setLocalError('');
                clearError();
              }}
            />
          )}

          <form className="auth-form" onSubmit={handleSubmit}>
            <Input
              name="username"
              label="用户名 / 邮箱"
              placeholder="请输入用户名或邮箱"
              value={formData.username}
              onChange={handleChange}
              icon={
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              }
            />

            <Input
              name="password"
              type="password"
              label="密码"
              placeholder="请输入密码"
              value={formData.password}
              onChange={handleChange}
              icon={
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              }
            />

            <div className="auth-options">
              <Link to="/forgot-password" className="auth-link">
                忘记密码？
              </Link>
            </div>

            <Button type="submit" fullWidth loading={loading}>
              登录
            </Button>
          </form>

          <div className="auth-footer">
            <p>
              还没有账号？
              <Link to="/register" className="auth-link" style={{ marginLeft: '0.5rem' }}>
                立即注册
              </Link>
            </p>
          </div>
        </div>

        <p className="auth-copyright">
          © 2024 账号管理系统. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;

